import { render } from "./standardized-patient.vue?vue&type=template&id=368bc7eb&ts=true"
import script from "./standardized-patient.vue?vue&type=script&lang=ts"
export * from "./standardized-patient.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__